/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import {
  Divider,
} from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  CommonPagination,
  ScreenContainer,
} from '../../CommonComponents';
import {
  getAllDeletedSites,
  getDeletedSitesByEstimateId,
  updatePrimaryQuery,
} from '../../redux/actions/sites';
import SitesFilter from '../../CommonComponents/SitesFilter/SitesFilter';
import PrimaryFilters from '../../CommonComponents/PrimaryFilters';
import FallbackCard from '../../CommonComponents/FallbackCard';
import { exportCompeteSiteReports, exportSites, importSites } from '../../redux/actions/common';
import DeletedSiteTable from './DeletedSiteTable';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const MapDeletedSites = ({
  getAllSitesAction,
  totalSitePages,
  updateQuery,
  primaryQuery,
  searchQuery,
  fetchSites,
}) => {
  const query = useQuery();
  const history = useHistory()
  const page = parseInt(query.get('page') || '1', 10);
  const [showSites, enableSites] = useState(false);
  const [estimateId, setEstimateId] = useState(0);

  useEffect(() => {
    const pno = query.get('page')
    if (showSites && pno) { getAllSitesAction(page, searchQuery, primaryQuery); }
  }, [query, getAllSitesAction, searchQuery, primaryQuery, showSites, page]);

  const fetchAllSite = (val) => {
    if (query.has('estimateId')) {
      query.set('estimateId', val)
    } else {
      query.append('estimateId', val)
    }
    query.delete('page')
    history.push('/map-deleted-sites')
    updateQuery(query.toString())
    setEstimateId(val);
    fetchSites(val);
    enableSites(true);
  }

  return (
    <ScreenContainer title="Manage Deleted Sites">
      <PrimaryFilters
        visibleProduct
        visibleEstimate
        fetchFunction={fetchAllSite}
        location="allsites"
        showFetchButton
      />
      <br />
      {showSites
        ? (
          <>
            <SitesFilter currentLocation="map-deleted-sites" estimateId={estimateId} />
            <div className="row">
              <Divider />
              <div className="col-12">
                <br />
                <DeletedSiteTable estimateId={estimateId} />
                {totalSitePages > 1 ? (
                  <CommonPagination
                    baseUrl="assign-flex-date"
                    totalPages={totalSitePages}
                  />
                ) : null}
                <br />
                <br />
              </div>
            </div>
          </>
        )
        : <FallbackCard text="Fetch the sites to start" />}
    </ScreenContainer>
  );
};

const mapState = (state) => ({
  totalSitePages: state.sites.totalSitePages,
  searchQuery: state.sites.searchQuery,
  primaryQuery: state.sites.primaryQuery,
});

const mapActions = {
  getAllSitesAction: getAllDeletedSites,
  fetchSites: getDeletedSitesByEstimateId,
  updateQuery: updatePrimaryQuery,
  exportSite: exportSites,
  exportCompleteSites: exportCompeteSiteReports,
  importSite: importSites,
};

export default connect(mapState, mapActions)(MapDeletedSites);
